import styled from "styled-components";

export const CMFinancials = styled.div((props) => ({
  paddingTop: "0 !important",
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",

  "& .tooltip-content": {
        display:"flex", 
        gap:"5px",
        flex:1
  },

  "& h3": {
    margin: 0,
    marginBottom: "12px",
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.workSans,
    [`@media (min-width: 2000px)`]: {
      fontSize:"4vh"
    },
  },
  "& .financials-details": {
    [`@media (min-width: 2000px)`]: {
      "& div": {
        fontSize:"2vh"
      },
    },
  },
  "& .financials": {
    [`@media (min-width: 2000px)`]: {
      width:"30%",
    },
  },
  
  "& .included-rights": {
    [`@media (min-width: 2000px)`]: {
      width:"60%",
      "& div": {
        fontSize:"2vh",
        width:"97%",
      },
      "& button": {
        fontSize:"2vh",
        width:"90%",
        textAlign:"right"
      },
    },
  },
  "& > div": {
    padding: "24px 0",
    "&.financials": { 
    },
    "&.included-rights": {
     
      gridTemplateRows: "repeat(7,minmax(0,0.75fr))",
      columnGap: "50px", 

      "& > div": {
        display: "grid",
        gridTemplateColumns: "1fr 0.5fr",
        columnGap: "50px", 
        [`@media (min-width: 2000px)`]: {
          gridTemplateColumns: "1fr 1fr",
        },
        "& > div": {
          padding: '3px 15px 3px 0',
        }
      },
    },
    "& > div": {
      "& > div": {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        //gap: "1.5rem",
        padding: "3px 0",
        alignContent: "space-around",
        width: 400,
        [`@media (min-width: 2000px)`]: {
          width: "100%", 
        },
        "& > div:last-of-type": {
          fontWeight: 300,
          [`@media (min-width: 2000px)`]: {
            fontSize:"2vh"
          },
        },
      },
    },
  },
  ".tooltip-box": {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    color: "black",
    padding: "40px",
    borderRadius: "10px",
    zIndex: 1000,
    opacity: 0.95,
    fontSize: "1rem",
    textAlign: "left",
    maxWidth: "80%",
    maxHeight: "80%",
    overflowY: "auto",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  
  ".close-button": {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 0,
    fontSize:" 1rem",
    padding: "10px",
  },

  ".open-button": {
    marginLeft: '10px',
    background: 'none',
    border: 'none',
    color: '#4090cd',
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: 0,
    fontSize: "1rem",
    fontFamily: "'Jost', sans-serif",
    [`@media ${props.theme.breakpoints.lg}`]: {
      marginLeft: 0
    },
    [`@media ${props.theme.breakpoints.xs}`]: {
      textAlign: "left"
    }
  },

  [`@media ${props.theme.breakpoints.xss}`]: {
    "& > div": {
      "&.financials": {
        
        "& > div": {
          gridTemplateColumns: "1fr 0fr",
          
          
        },
      },
      "& > div": {
        "& > div": {
          width: "95%",
        },
      },
    },
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",

    "& > div": {
      width: "100%",
      padding: `${props.theme.spacers["5"]} 0`,
      "&.financials": {
        width: "99%",
      },
      "&.included-rights": {
        width: "100%",

        "& > div": {
          display: "grid",
          gridAutoFlow: "row",
          gridTemplateColumns: "none",
          gridTemplateRows: "none",
        },
      },
    },
  },

  [`@media (min-width: 993px) and (max-width: 1300px)`]: {
    flexDirection: "column",

    "&.auction-financials > div": {
      width: "100%",
      padding: `${props.theme.spacers["5"]} 0`,
      "&.financials": {
        width: "99%",
      },
      "&.included-rights": {
        width: "100%",

        "& > div": {
          display: "grid",
          gridAutoFlow: "row",
        
          gridTemplateColumns: "none",
          gridTemplateRows: "none",
        },
      },
    },
  },

  [`@media ${props.theme.breakpoints.xs}`]: {
    "& > div": {
      "&.financials": {
        width: "99%",
      },
      "&.included-rights": {
        width: "100%",

        "& > div": {
          display: "grid",
          gridAutoFlow: "row",
       
          gridTemplateColumns: "none",
          gridTemplateRows: "none",
        },
      },
     
    },
  },

 
}));
export const TransactionContend = styled.button((props) => ({
  paddingTop:"10px",
  paddingRight:"0",
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > img': {
      width: '12px',
      height: '12px',
      marginTop: '-10px',
      filter: 'invert(46%) sepia(83%) saturate(449%) hue-rotate(86deg) brightness(92%) contrast(89%)',
  },
}));

export const LoadContent = styled.div((props) => ({
  justifyContent: "flex-end",
  textAlign:"right",
  display: "flex", 
  '& svg':{
    margin: "0 !important",
    width: "auto !important",
    height: "auto !important",
    paddingBottom: "0 !important",
  },
  '& > div':{
    width:"20px",
  }
}));

export const ToolTipContent = styled.div((props) => ({
 "& .header_tool": {
  display: "flex !important", 
  justifyContent: "space-between !important"
 },
 "& .close_tool": {
  background: "none", 
  color: "white",
  border: "none",
  [`@media (min-width: 2000px)`]: {
    fontSize:"2vh"
  },
 },

 [`@media (min-width: 2000px)`]: {
  width:"20vh",
  height:"20vh",
  "& h5": {
    fontSize: "2vh",
  },
  "& li": {
    fontSize: "2vh",
  },
},
}));